import { Helmet } from "react-helmet-async";

// Central defaults so per-page overrides stay tiny and consistent.
const SITE = "Mayoto";
const BASE = "https://mayotofocus.com";
const DEFAULT_DESC =
  "Mayoto is a Nigerian investment company creating structured opportunities across Real Estate, Agriculture and Strategic Business Investments. Invest smart. Grow together.";
const DEFAULT_IMAGE = `${BASE}/og-cover.svg`;

/**
 * Per-page SEO. Injects title, description, canonical, OG, Twitter card, robots
 * and optional JSON-LD structured data — safely, without touching any existing
 * marketing/functionality code.
 */
export default function PageSEO({
  title,
  description = DEFAULT_DESC,
  canonicalPath,
  image = DEFAULT_IMAGE,
  noIndex = false,
  jsonLd = null,
  ogType = "website",
}) {
  const fullTitle = title ? `${title} · ${SITE}` : `${SITE} – Investment Opportunities`;
  const url = canonicalPath ? `${BASE}${canonicalPath}` : `${BASE}/`;
  const robotsValue = noIndex ? "noindex,nofollow" : "index,follow,max-image-preview:large";
  const ldBlocks = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={robotsValue} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:site_name" content={SITE} />
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="en_NG" />

      {/* Twitter / X */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {ldBlocks.map((block, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(block)}</script>
      ))}
    </Helmet>
  );
}
